import type { LucideIcon } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from '@teach/ui'

interface Props {
  icon: LucideIcon
  title: string
  hint: string
  actionLabel: string
  actionTo: string
}

/**
 * Экран-заглушка («страница не найдена», «нет доступа»): значок в круге,
 * заголовок, пояснение и одна кнопка. Один вид на все такие экраны — раньше
 * 404 был серым листом, а «нет доступа» висел по-английски без оформления.
 */
export const StatusScreen = ({ icon: Icon, title, hint, actionLabel, actionTo }: Props) => (
  <div className="flex min-h-dvh items-center justify-center bg-background p-6">
    <div className="flex max-w-sm flex-col items-center gap-4 text-center">
      <div className="flex size-14 items-center justify-center rounded-full bg-muted">
        <Icon className="size-7 text-muted-foreground" />
      </div>
      <h1 className="text-2xl font-semibold">{title}</h1>
      <p className="text-muted-foreground">{hint}</p>
      <Button asChild>
        <Link to={actionTo}>{actionLabel}</Link>
      </Button>
    </div>
  </div>
)
